/**
 * @file Thunder
 */
import {BaseLog} from '@baidu/feed-baselog';

let baseLog;
export const initBaseLog = data => {
    const {bsData} = data;
    baseLog = new BaseLog({
        mode: '1',
        params: {},
        tParams: {
            ct: 2,
            logFrom: 'recdetail',
            logid: bsData.logid || '0',
            ssid: bsData.ssid || '0',
            sid: bsData.sid || '0',
            curRid: bsData.nid || '0',
            logExtra: JSON.stringify({
                rid: bsData.nid,
                nid: `news_${bsData.nid}`,
                pos: 0,
                extra: '',
                isBaijiahao: bsData.isBaiJiaHao,
                login: bsData.header && bsData.header.islogin
            })
        }
    });
};

export const sendBaseLog = (data, callback) => {
    if (!baseLog) {
        // eslint-disable-next-line no-console
        return console.error('baseLog not init:', data);
    }
    const ubcId = '13587'; // thunder迁移ubc默认ubcId
    const {logExtra, ...params} = data;
    if (logExtra) {
        params.logExtra = JSON.stringify(logExtra);
    };
    baseLog.sendLog({...params}, ubcId, callback);
};